import React, {
  createContext,
  useContext,
  useReducer,
  useState
} from 'react';

import { AgentConfig } from '@/types/agent';

import { ValidationErrorMap } from '../util/validation';
import { AgentEditAction, agentEditReducer } from './agentEditReducer';


type AgentEditContextType = {
  config: AgentConfig | null;
  dispatch: React.Dispatch<AgentEditAction>;
  validationErrors: ValidationErrorMap;
  setValidationErrors: React.Dispatch<React.SetStateAction<ValidationErrorMap>>;
  stepHasValidationErrors: ( stepId: string ) => boolean;
};

const AgentEditContext = createContext<AgentEditContextType | undefined>( undefined );

export function AgentEditProvider( { children }: { children: React.ReactNode } ) {
  const [ config, dispatch ] = useReducer( agentEditReducer, null );
  const [ validationErrors, setValidationErrors ] = useState<ValidationErrorMap>( {} );

  const stepHasValidationErrors = ( stepId: string ): boolean => {
    return !!validationErrors[stepId];
  };

  return (
    <AgentEditContext.Provider value={ { config, dispatch, validationErrors, setValidationErrors, stepHasValidationErrors } }>
      { children }
    </AgentEditContext.Provider>
  );
}

export function useAgentEdit() {
  const context = useContext( AgentEditContext );
  if ( !context ) {
    throw new Error( 'useAgentEdit must be used within AgentEditProvider' );
  }
  return context;
}
